// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "Website content", 
			attr: "content",  
			value: "", 
			id:"topic",
			placeholder: "Choose a topic to produce content tags.", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Website content is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Website content", 
			attr: "content",  
			value: "Dancing", 
			id:"topic",
			placeholder: "Choose a topic to produce content tags.", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Website content is  Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`1. "Welcome to our website, dedicated to all things dancing! Here you'll find information on different types of dance, as well as tips and tricks for improving your skills."\nDiscover the world of dancing at our website! Here you'll find a wealth of information on different types of dance, plus helpful tips and tricks to help you become a better dancer.`,

		
       
        // 1. Gamers Unite! \n2. Play and Win!\n3. Game On!\n4. Let's Play Games!
       
	}
	}
	
	
	export default obj
	
	